// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import InvoiceForm from '../../components/order/TechForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {orderAddItem, orderSetItem, orderGetItem,orderItemId,invoiceGetItem} from "../../actions/orderActions";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.order.getItem,
        invoiceInitialValues: state.order.invoiceGetItem,
        userValue : state.app.currentUser,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getOrderItem: (id) => {
        dispatch(getOrderItem(id));
    },
    getInvoiceItem: (id) => {
        dispatch(getInvoiceItem(id));
    },
    setOrderId: (orderId) => {
        return(dispatch(orderItemId(orderId)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode === 'add')
            dispatch(add(value));
        else
            dispatch(guarantee(value));
    }

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const guarantee = (values) => {

    return (dispatch, getState) => {
        let states = getState();

        let guarantee_table = values.guarantee_table
        let technician_description = values.technician_description
        let products = values.products
        let services = values.services
        let orderId  = values.order._id

        let formData = {
            'guarantee_table'        : guarantee_table,
            'technician_description' : technician_description,
            'products' : products,
            'services' : services,
            'order'    : orderId,
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('guarantee', formData).then(res => {
            dispatch(orderAddItem(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const add = (values) => {

    return (dispatch, getState) => {
        let states = getState();

        let products = values.products
        let services = values.services
        let orderId  = values.order._id

        let formData = {
            'used_products': products,
            'used_services': services
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('order/tech/'+orderId, formData).then(res => {
            dispatch(orderAddItem(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list'}), 100)

            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getOrderItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('order/offline/'+id).then(orderInfo => {
            dispatch(orderGetItem(orderInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}

const getInvoiceItem = (id) => {
    let formData = {'customer_by':id,'size':100};
    return (dispatch, getState) => {
        API_FETCH.get('guarantee/',{params:formData}).then(guaranteeList => {
            dispatch(invoiceGetItem(guaranteeList.data.lists));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
